import { httpGet, httpPost } from 'core/utils/httpClient';
import {
  GetCreateUserIfNewRequest,
  UpdateDemographicInfoRequest,
  UpdateUserProfile,
  UpdateEmailSubscriptionStatus,
  GetAccountDetails,
  IActiveSession,
} from '../models/api';

export const getAccountDetails = (data: GetCreateUserIfNewRequest): Promise<GetAccountDetails> =>
  httpPost('/auth/get-account-details', data);

export const getIP = (): Promise<{ ip: string }> => httpGet('/auth/get-ip');

export const createUserIfNew = (data: GetCreateUserIfNewRequest): Promise<{ created: boolean }> =>
  httpPost('/auth/create-user-if-new', data);

export const updateDemographicInformation = (params: UpdateDemographicInfoRequest) =>
  httpPost('/auth/update-demographic-information', params);

export const signOutUser = (): Promise<{ ip: number }> => httpGet('/auth/sign-out');

export const signOutFromAllSessions = () => httpGet('/auth/sign-out-from-all');

export const signOutFromAllWithEmail = (email: string) => httpPost('/auth/sign-out-from-all-by-email', { email });

export const updateUserProfile = (data: UpdateUserProfile) =>
  httpPost(`auth/update-user-profile?uid=${data.uid}`, {
    fullName: data.fullName,
    acceptedPremiumModesTnc: data.acceptedPremiumModesTnc,
    skippedPersonalization: data.skippedPersonalization,
    shownNps: data.shownNps,
    npsScore: data.npsScore,
    affiliatePartnerName: data.affiliatePartnerName,
  });

export const updateEmailSubscriptionStatus = (data: UpdateEmailSubscriptionStatus) =>
  httpPost('auth/update-email-subscription-status', data);

// export const getIpData = () => httpGet('utils/detect-location');

export const getActiveSessions = (): Promise<IActiveSession[]> => httpGet('auth/sessions');

export const handleCampaign = (data: { campaign: string; new: boolean }): Promise<{ premium: boolean }> =>
  httpPost('auth/campaign', data);
